import React from 'react'
import styled from 'styled-components'
import {Box} from 'grommet/components/Box'
import {Layer} from 'grommet/components/Layer'
import {Button} from 'grommet/components/Button'
import Icons from '../Icons'

const StyledBox = styled(Box)`
  color: white;
`

const Notification = ({show, onClose, message1, message2}) => {
  if (show) {
    return (
      <Layer
        position="center"
        modal
        responsive={false}
        onEsc={onClose}
        plain
        onClickOutside={onClose}
      >
        <Box
          align="start"
          pad={{vertical: 'small', horizontal: 'small'}}
          width="medium"
        >
          <StyledBox
            align="center"
            direction="row"
            gap="small"
            round="medium"
            elevation="medium"
            pad={{vertical: 'xsmall', horizontal: 'small'}}
            background="#3395fe"
          >
            <Box align="center" direction="row" gap="medium" pad="small">
              <div>
                <div>{message1}</div>
                <div>{message2}</div>
              </div>
              <div onClick={onClose}>
                <Icons icon="CANCEL" />
              </div>
            </Box>
            <Button onClick={onClose} plain />
          </StyledBox>
        </Box>
      </Layer>
    )
  } else {
    return null
  }
}

export default Notification

Notification.defaultProps = {
  show: false,
  message1: '',
  message2: ''
}
